import _ from "lodash";
import React from "react";

import { INTERACTION_TYPE } from "MessagingV2/modules/Utils";
import PollMessage from "./PollMessage";
import FormMessage from "./FormMessage";

const MessageInteraction = props => {
  const { message } = props;

  const attachment = _.first(_.get(message, "attachments", []));
  if (_.isEmpty(attachment)) {
    return null;
  }
  const type = _.get(attachment, "type");

  switch (type) {
    case INTERACTION_TYPE.POLL:
      return <PollMessage message={message} />;
    case INTERACTION_TYPE.FORM:
      return <FormMessage message={message} />;

    default:
      return null;
  }
};
export default MessageInteraction;
